import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import classNames from 'classnames'

export default function BarChartPagination ({ pageInfo, onPageRequest, totalCount, fakeCount, isSiteJobResourceDisplay }) {
  return (
    <div className={classNames(styles.pagination, { [styles.hidden]: !pageInfo, [styles.siteJobResourceDisplay]: isSiteJobResourceDisplay })}>
      <button
        className={classNames(styles.button, {
          [`${styles.enabledButton}`]: pageInfo?.hasPreviousPage,
          [`${styles.disabledButton}`]: !pageInfo?.hasPreviousPage
        })}
        type='button'
        disabled={!pageInfo?.hasPreviousPage}
        onClick={() => onPageRequest('before', pageInfo.startCursor)}>
        &larr; Previous
      </button>
      <div className={styles.results}>
        {fakeCount && <>Displaying Results {fakeCount.start} to {fakeCount.end}</>}
      </div>

      <button
        className={classNames(styles.button, {
          [`${styles.enabledButton}`]: pageInfo?.hasNextPage,
          [`${styles.disabledButton}`]: !pageInfo?.hasNextPage
        })}
        type='button'
        disabled={!pageInfo?.hasNextPage}
        onClick={() => onPageRequest('after', pageInfo.endCursor)}>
        Next &rarr;
      </button>
    </div>
  )
}

BarChartPagination.propTypes = {
  onPageRequest: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageInfo: PropTypes.shape({
    endCursor: PropTypes.string,
    hasNextPage: PropTypes.bool.isRequired,
    hasPreviousPage: PropTypes.bool.isRequired,
    startCursor: PropTypes.string
  }).isRequired,
  fakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  }),
  isSiteJobResourceDisplay: PropTypes.bool
}
